import { Box, styled } from '@mui/material';

type TRootProps = {
  /** 與元件 props `editorMinHeightPx` 對齊；不轉發至 DOM */
  editorMinHeightPx: number;
};

/**
 * ReactQuill（Snow）外層容器：版面寬度與 Quill 內建 class 的覆寫集中於此。
 */
export const richTextEditor = {
  Root: styled(Box, {
    shouldForwardProp: prop => prop !== 'editorMinHeightPx',
  })<TRootProps>(({ editorMinHeightPx }) => ({
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    '& .ql-toolbar.ql-snow': { flexWrap: 'wrap' },
    /**
     * Snow 主題只為內建 size（small/large…）定義 ::before 文案；自訂 px 需自行顯示 data-value，
     * 否則每個選項都會沿用基底規則而全部顯示「Normal」。
     */
    '& .ql-snow .ql-picker.ql-size .ql-picker-item::before': {
      content: 'attr(data-value)',
    },
    '& .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="false"]::before':
      {
        content: '"預設"',
      },
    '& .ql-snow .ql-picker.ql-size .ql-picker-label::before': {
      content: 'attr(data-value)',
    },
    '& .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="false"]::before, & .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before':
      {
        content: '"預設"',
      },
    '& .ql-container': {
      minHeight: editorMinHeightPx + 20,
      maxWidth: '100%',
    },
    '& .ql-editor': {
      minHeight: editorMinHeightPx,
      maxWidth: '100%',
      overflowX: 'hidden',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      '& img, & iframe, & video': {
        maxWidth: '100%',
        height: 'auto',
      },
    },
  })),
};
